export default __webpack_public_path__ + "static/media/005-fire.a124859d.svg";